import React, { useState, useEffect } from 'react';
import { noop } from 'lodash';
import { TreeSelect } from 'antd';
import { useTranslation } from 'react-i18next';

/**
 * TreeSelectCutoff component - used for cutoff element (must be pre-selected).
 *
 * @param {Object} props - Props for the TreeSelectCutoff component.
 * @param {Array} props.options - The options for the tree select.
 * @param {Function} props.onChange - The function to be called when the tree select value changes.
 * @param {Boolean} props.clear - A flag indicating whether to clear the tree select value.
 * @returns {JSX.Element} The TreeSelectCutoff component.
 * @example
 * 	<TreeSelectCutoff
		options={filters.cutoffMonths}
		onChange={setCutoffDate}
		clear={false}
	/>
*/
function TreeSelectCutoff({ options, onChange, clear, ...props }) {
	const currentDate = new Date();
	const currentMonth = currentDate.getMonth() + 1;

	const monthsToShow = () => {
		const monthsToEnd = 12 - currentDate.getMonth();
		return monthsToEnd <= 3 ? monthsToEnd : 3;
	}

	const selectedMonths = () => {
		const monthsArray = [];
		for (let i = 0; i < monthsToShow(); i++) {
			let month = currentMonth + i;
			let year = currentDate.getFullYear();
			year = month > 12 ? year + 1 : year;
			month = month > 12 ? month - 12 : month;
			monthsArray.push(`${month}-${year}`);
		}
		return monthsArray.map((month) => month);
	}

	const [value, setValue] = useState(selectedMonths);

	const { t } = useTranslation();

	const filtersTree = options.map((item) => {
		const year = item.year.toString();

		return {
			title: year,
			key: year,
			value: year,
			children: item.months.map((month) => {
				return {
					title: month.title,
					key: month.value,
					value: month.value,
				};
			}),
		};
	});

	useEffect(() => {
		if (clear) {
			onChange([]);
			setValue([]);
		} else {
			onChange(value);
		}
	}, [value, clear, onChange]);

	return (
		<TreeSelect
			placeholder={t('selectFilter')}
			optionLabelProp='label'
			allowClear
			showSearch
			treeDefaultExpandAll
			virtual={false}
			treeCheckable
			value={clear ? [] : value}
			showCheckedStrategy='SHOW_PARENT'
			onChange={setValue}
			treeData={filtersTree}
			{...props} />
	);
}

TreeSelectCutoff.defaultProps = {
	options: [],
	clear: false,
	onChange: noop,
};

export default TreeSelectCutoff;